import SevereWeatherAlertsMap from 'components/Maps/SevereWeatherAlertsMap/SevereWeatherAlertsMap';

export default function AdvisoriesMap() {
  const date = new Date().toLocaleDateString();

  return (
    <div className="d-flex flex-column mb-4 w-100 h-100">
      <div className="d-flex w-100">
        <div className="d-flex w-100 m-3">
          <div className="fs-3 fw-bold w-100 border-light border-bottom">{date} Advisories Map</div>
        </div>
      </div>
      <div className="w-100 h-md h-lg-lg h-xl-xl">
        <SevereWeatherAlertsMap fullScreen />
      </div>
    </div>
  );
}
